import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { attachArticlesToNote } from "./breadcrumbSlice"
import {attachNoteToAttachment, setNoteAttachmentError} from "./noteAttachmentsSlice"
import axios from "axios"

export const dragType = {
	ATTACHMENT: 0,
	ARTICLE: 1
}

const handleCrossWorkspaceError = (error, dispatch, targetWorkspaceId, itemType) => {
	console.error(`FAILED TO COPY ${itemType} TO NEW WORKSPACE: `, error)
	if (error.response) {
		const message = error.response.status === 401
			? "Insufficient permissions in target workspace, contact the owner of that workspace."
			: error.response.data || error.message || `Failed to copy ${itemType} to new Workspace`
		dispatch(setNoteAttachmentError({ workspaceId: targetWorkspaceId, error: message }))
	}
}

export const setOnDrop = createAsyncThunk(
	"articleDragSlice/setOnDrop",
	async ({ note }, {getState, dispatch, fulfillWithValue, rejectWithValue}) => {
		try {

			const { articleDragSlice, user } = getState()
			const { dragItem, dragType: payloadType, sourceWorkspaceId } = articleDragSlice
			const { workspaceId: targetWorkspaceId } = note

			if (sourceWorkspaceId !== targetWorkspaceId) {
				try {
					if(payloadType === dragType.ARTICLE) {
						await axios.post(`/api/workspace/${targetWorkspaceId}/article?sharedWorkspaceId=${sourceWorkspaceId}`, dragItem)
					} else if (payloadType === dragType.ATTACHMENT) {
						await axios.post(`/api/workspace/${targetWorkspaceId}/user/${user.value.id}/attachment/copy`, dragItem)
					}
				} catch (error) {
					handleCrossWorkspaceError(error, dispatch, targetWorkspaceId, payloadType)
					return rejectWithValue("Failed cross-workspace entity copy: ", payloadType)
				}
			}

			if (payloadType === dragType.ARTICLE) {
				await dispatch(attachArticlesToNote({
					articles: dragItem,
					note,
					sourceWorkspaceId
				}))
				return fulfillWithValue(targetWorkspaceId)
			}

			if (payloadType === dragType.ATTACHMENT) {
				await dispatch(attachNoteToAttachment({
					attachment: dragItem,
					note,
					workspaceId: targetWorkspaceId
				}))
				return fulfillWithValue(targetWorkspaceId)
			}

			return rejectWithValue("Invalid drag item type")
		} catch (e) {
			console.error("setOnDrop failed: ", e)
			return rejectWithValue(e)
		}
	}
)

// Initial state
const initialState = {
	dragItem: null,
	dragType: null,
	sourceWorkspaceId: null,
	sourceCompositeKey: null,
}

const articleDragSlice = createSlice({
	name: "articleDragSlice",
	initialState,
	reducers: {
		setDragItem: (state, action) => {
			const { item, type, workspaceId, compositeKey } = action.payload
			state.dragItem = item
			state.dragType = type
			state.sourceWorkspaceId = workspaceId
			state.sourceCompositeKey = compositeKey
		},
		clearDragItem: () => initialState,
	},
	extraReducers: (builder) => {
		builder
			.addCase( setOnDrop.fulfilled, articleDragSlice.caseReducers.clearDragItem )
			.addCase( setOnDrop.rejected, articleDragSlice.caseReducers.clearDragItem )
	}
})

// Export actions generated from createSlice
export const { setDragItem, clearDragItem } = articleDragSlice.actions

// Export the reducer
export default articleDragSlice.reducer
